import { useContext } from "react";
import { PageContext } from "pages/[[...slug]]";

import FooterCareer from "./variants/FooterCareer";
import FooterCarDetail from "./variants/FooterCarDetail";
import FooterDefault from "./variants/FooterDefault";

//  0:Standard
//  1:Karriere
// -1:Deaktiviert

const Footer = ({ items = {}, service = {}, meta = {} }) => {
  const { config, appearance } = useContext(PageContext);
  const { footerLayout = "0" } = appearance;

  switch (footerLayout.toString()) {
    case "0":
      return (
        <FooterDefault
          items={items}
          service={service}
          meta={meta}
          config={config}
        />
      );
    case "1":
      return <FooterCareer config={config} items={meta} />;
    case "-1":
      return <FooterCarDetail />;
    default:
      return (
        <FooterDefault
          items={items}
          service={service}
          meta={meta}
          config={config}
        />
      );
  }
};
export default Footer;
